// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1R9CY","productName":"Table_productName__1mV2q"};